export function getEnvVar(key: string, defaultValue: string = '') {
    return process.env[`REACT_APP_${key}`] ?? defaultValue;
}